/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { Model } from '@app/shared/models/model.model';
import { EventGroup } from '@app/events/events-groups/event-group.model';

@Injectable({
  providedIn: 'root',
})
export class HotelsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/hotels', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((hotel: any) => {
          return new Hotel().deserialize(hotel);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(hotel: Hotel): Observable<Hotel> {
    return this.http.put('v1/hotels/' + hotel.id, hotel).pipe(
      map((response: HttpResponse) => {
        return new Hotel().deserialize(response.data);
      })
    );
  }

  store(hotel: Hotel): Observable<Hotel> {
    return this.http.post('v1/hotels', hotel).pipe(
      map((response: HttpResponse) => {
        return new Hotel().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/hotels/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Hotel().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/hotels/' + id);
  }

  updateTranslations(hotel: EventGroup, translations: any): Observable<any> {
    return this.http.put('v1/hotels/translations/' + hotel.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }

  // @todo: да се завърши
  export(query: ApiQuery = new ApiQuery()): Observable<any> {
    return this.http.download('v1/hotels', query.buildGetOptions());
  }
}
